import {
  EventCategory,
  EventPriority,
  RetentionPolicy,
  RuntimeEventSensitivity
} from '../contracts'

const MINUTE = 60 * 1000
const HOUR = 60 * MINUTE

export const DEFAULT_RETENTION_POLICY: RetentionPolicy = {
  maxEvents: 20000,
  defaultTtlMs: 24 * HOUR,
  categoryTtlMs: {
    [EventCategory.AUTHORIZATION]: 7 * 24 * HOUR,
    [EventCategory.RUNTIME]: 24 * HOUR,
    [EventCategory.ACCOUNT_BALANCE]: 72 * HOUR,
    [EventCategory.OPERATIONAL]: 7 * 24 * HOUR,
    [EventCategory.PERFORMANCE]: 12 * HOUR,
    [EventCategory.SECURITY]: 14 * 24 * HOUR,
    [EventCategory.ERROR]: 7 * 24 * HOUR
  },
  sensitivityTtlMs: {
    [RuntimeEventSensitivity.PUBLIC]: 24 * HOUR,
    [RuntimeEventSensitivity.OPERATIONAL]: 72 * HOUR,
    [RuntimeEventSensitivity.SENSITIVE]: 12 * HOUR,
    [RuntimeEventSensitivity.AUDIT]: 14 * 24 * HOUR
  }
}

export function priorityFromPayload(value: unknown): EventPriority {
  if (typeof value !== 'string') return EventPriority.NORMAL
  const normalized = value.toLowerCase()
  if (normalized === EventPriority.LOW) return EventPriority.LOW
  if (normalized === EventPriority.HIGH) return EventPriority.HIGH
  if (normalized === EventPriority.CRITICAL) return EventPriority.CRITICAL
  return EventPriority.NORMAL
}